import { __assign } from "tslib";
import React from 'react';
import { CommonWrapper } from '@skbkontur/react-ui/internal/CommonWrapper';
import { jsStyles } from './TopBar.styles';
/**
 * Контейнер для сдвига к началу
 *
 * @visibleName TopBar.Start
 */
export var TopBarStart = function (props) { return (React.createElement(CommonWrapper, __assign({}, props),
    React.createElement("div", { className: jsStyles.startItems() }, props.children))); };
TopBarStart.__KONTUR_REACT_UI__ = 'TopBarStart';
